import { AxiosRequestConfig } from "axios";
import http from "../base/http.service";
import { FileDto } from "./files.dto";

const services = {
  Add(dto: any, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<FileDto[]>("files", dto, config);
  },
  Get(id: string, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<File>(`files/${id}`, config);
  },
  Delete(id: string, config?: AxiosRequestConfig<any> | undefined) {
    return http.remove<FileDto>(`files/${id}`, config);
  },
  CopyFile(id: string, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<FileDto>(`files/${id}/copyFile`, config);
  },
};

export default services;
